import { useLazyQuery, useMutation } from "@apollo/client";
import { useContext, useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { customSelectDropDown } from "../../../components/styled/customSelect";
import { AppContext } from "../../../context";
import {
  ADD_TO_RECRUITER_FOLDER,
  GET_FOLDER_LISTING,
  MOVE_CANDIDATE_IN_FOLDER,
} from "../gql";
import CreateFolderModal from "./CreateFolderModal";

const AddRecruiterFolderModal = ({
  isOpen,
  toggle,
  recordToAdd,
  refetch,
  clearRecord,
  preFolder = null,
  modalFor = "Add To Recruiter Folder",
}) => {
  const { theme } = useContext(AppContext);
  const [folderId, setFolderId] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const createModalToggle = () => setCreateModal(!createModal);
  const [getFolderList, { loading, data }] = useLazyQuery(GET_FOLDER_LISTING);
  const [addToRecruiterFolder, { loading: waiting }] = useMutation(
    ADD_TO_RECRUITER_FOLDER
  );
  const [moveToRecruiterFolder, { loading: moveLoading }] = useMutation(
    MOVE_CANDIDATE_IN_FOLDER
  );

  const _getFolderList = () => {
    getFolderList({
      variables: {
        limit: 50,
        page: 1,
        searchText: "",
      },
    });
  };

  const addToFolder = async () => {
    if (folderId) {
      setErrMsg("");
      let candidateIds = recordToAdd?.map((item) => item?.candidateId);
      let recruiterFolder = { folderId, preFolder, candidateIds };
      let res = await addToRecruiterFolder({ variables: { recruiterFolder } });
      if (res?.data?.addToRecruiterFolder?.candidate?.length) {
        let candidate = res?.data?.addToRecruiterFolder?.candidate?.map(
          (item) => item?.fullName
        );
        setErrMsg(
          `Candidate ${candidate?.join(", ")} are already exist in this folder!`
        );
      } else {
        toast.success("Updated successfully!");
        setFolderId("");
        toggle();
        refetch();
      }
    } else {
      setErrMsg("Must select the folder!");
    }
  };
  const moveToFolder = async () => {
    if (folderId && preFolder) {
      setErrMsg("");
      let candidateIds = recordToAdd?.map((item) => item?.candidateId);
      let moveCandidateInput = {
        moveFolderId: folderId,
        currentFolderId: preFolder,
        candidateIds,
      };
      let res = await moveToRecruiterFolder({
        variables: { moveCandidateInput },
      });
      if (res?.data?.moveCandidate?.candidate?.length) {
        let candidate = res?.data?.moveCandidate?.candidate?.map(
          (item) => item?.fullName
        );
        setErrMsg(
          `Candidate ${candidate?.join(", ")} are already exist in this folder!`
        );
      } else {
        toast.success("Moved successfully!");
        setFolderId("");
        clearRecord();
        toggle();
        refetch();
      }
    } else {
      setErrMsg("Must select the folder!");
    }
  };

  useEffect(() => {
    _getFolderList();
    // eslint-disable-next-line
  }, []);

  const getFolderOptions = () => {
    if (data?.fetchAllFolders?.recruiterFolders?.length) {
      let options = [];
      if (preFolder) {
        options = data?.fetchAllFolders?.recruiterFolders
          ?.filter((item) => item?.id !== preFolder)
          ?.map((item) => ({
            label: item?.folderName,
            value: item?.id,
          }));
      } else {
        options = data?.fetchAllFolders?.recruiterFolders?.map((item) => ({
          label: item?.folderName,
          value: item?.id,
        }));
      }
      return options;
    }
  };

  useEffect(() => {
    getFolderOptions();
    // eslint-disable-next-line
  }, [data?.fetchAllFolders?.recruiterFolders]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="revampDialog revampDialogWidth"
      >
        <ModalHeader toggle={toggle}>{modalFor}</ModalHeader>
        <ModalBody>
          <ul className="ml-3">
            {recordToAdd?.length &&
              recordToAdd?.map((item, index) => (
                <li key={index} className="light-text">
                  {item?.name}
                  <span className="text-muted ml-2">
                    ({item?.jobTitle}{" "}
                    {item?.jobTitle &&
                      item?.employment?.find((item) => !item?.endedAt) &&
                      "@"}
                    {item?.employment?.map(
                      (item) => !item?.endedAt && item?.companyName
                    )}
                    )
                  </span>
                </li>
              ))}
          </ul>
          <FormGroup>
            <div className="d-flex justify-content-between">
              <Label>Select Folder</Label>
              <Button
                className="border-0 bg-transparent text-info btn-sm"
                onClick={createModalToggle}
              >
                Create new folder
              </Button>
            </div>
            <Select
              isSearchable
              name="industry"
              options={getFolderOptions()}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(item: any) => setFolderId(item?.value)}
              styles={{ ...customSelectDropDown(theme) }}
            />
            <small className="text-danger">{errMsg}</small>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <button
            onClick={() => {
              toggle();
            }}
            type="button"
            className="buttonPrimary"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              preFolder ? moveToFolder() : addToFolder();
            }}
            className="buttonGenericStyle filledButton"
          >
            {loading ||
              waiting ||
              (moveLoading && <Spinner size="sm" className="mr-2" />)}
            {preFolder
              ? "Move"
              : modalFor === "Copy To Folder"
              ? "Copy"
              : " Add"}
          </button>
        </ModalFooter>
      </Modal>
      <CreateFolderModal
        isOpen={createModal}
        toggle={createModalToggle}
        folderId={null}
        folderName=""
        reFetch={() => _getFolderList()}
      />
    </>
  );
};

export default AddRecruiterFolderModal;
